import { API } from './resources'

export default {
  getVirtualLobbyByPath: (name) => {
    return API.get('/getvirtuallobby', { params: { name } })
  },
  createVirtualLobby: (data) => {
    return API.post('/createvirtuallobby', data)
  },
  updateVirtualLobby: (data) => {
    return API.post('/updatevirtuallobby', data)
  }
}
